// Utilitários de sanitização de inputs

export const sanitizarHTML = (texto: string): string => {
  const div = document.createElement('div');
  div.textContent = texto;
  return div.innerHTML;
};

export const sanitizarTexto = (texto: string): string => {
  return texto
    .replace(/[<>]/g, '') // Remove < e >
    .replace(/javascript:/gi, '') // Remove javascript:
    .replace(/on\w+=/gi, '') // Remove event handlers (onclick=, onload=, etc)
    .trim();
};

export const sanitizarURL = (url: string): string => {
  try {
    const urlObj = new URL(url);
    // Permite apenas http e https
    if (!['http:', 'https:'].includes(urlObj.protocol)) {
      return '';
    }
    return urlObj.href;
  } catch {
    return '';
  }
};

export const escaparHTML = (texto: string): string => {
  const map: { [key: string]: string } = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '/': '&#x2F;',
  };
  return texto.replace(/[&<>"'/]/g, (char) => map[char]);
};

export const removerScriptTags = (texto: string): string => {
  return texto.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
};

export const sanitizarInput = (valor: string): string => {
  return escaparHTML(sanitizarTexto(valor));
};
